import { render, staticRenderFns } from "./PointFingers.vue?vue&type=template&id=4955f53b"
import script from "./PointFingers.vue?vue&type=script&lang=js"
export * from "./PointFingers.vue?vue&type=script&lang=js"
import style0 from "./PointFingers.vue?vue&type=style&index=0&id=4955f53b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports